import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import type { Minister } from "../../types";

interface RemoveMinisterDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  minister: Minister | null;
  isSubmitting: boolean;
  onConfirm: () => void;
}

/**
 * Organism: Confirmation dialog for removing a minister from request
 */
export function RemoveMinisterDialog({
  open,
  onOpenChange,
  minister,
  isSubmitting,
  onConfirm,
}: RemoveMinisterDialogProps) {
  if (!minister) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirmar Eliminación</DialogTitle>
          <DialogDescription>
            ¿Está seguro de que desea eliminar al siguiente ministro de la solicitud?
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <div className="space-y-2">
            <p className="text-sm">
              <span className="font-semibold">Nombre:</span> {minister.full_name}
            </p>
            <p className="text-sm">
              <span className="font-semibold">Registro ADB:</span> {minister.adb_code}
            </p>
            <p className="text-sm">
              <span className="font-semibold">CI:</span> {minister.dni}
            </p>
          </div>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            Cancelar
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Eliminando..." : "Eliminar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
